import { Model } from './_model';

export default class Registration extends Model {
  get defaults() {
    return {
      bpId: '',
      registrationId: '',
      firstName: '',
      lastName: '',
      emailAddress: '',
      faceAmount: '',
      settlementDate: '',
      securityId: '',
      registrationStatus: '',
      investorCategory: {
        type: '',
        under: '',
      },
      investorIndividual: {
        salutation: '',
        lastName: '',
        firstName: '',
        middleName: ''
      },
      investor:'',
      dateBirthIncorporation:'',
      placeBirthIncorporation: '',
      domicile: '',
      nationality: '',
      usResident: '',
      usResidentCard: '',
      usCitizen: '',
      organizationType: '',
      parentCompany: '',
      telNo: '',
      presentAddress: {
        streetAddress: '',
        districtOrTown: '',
        city: '',
        stateProvinceRegion: '',
        country: '',
        zipCode: ''
      },
      permanentAddress: {
        streetAddress: '',
        districtOrTown: '',
        city: '',
        stateProvinceRegion: '',
        country: '',
        zipCode: ''
      },
      mailingAddress: {
        streetAddress: '',
        districtOrTown: '',
        city: '',
        stateProvinceRegion: '',
        country: '',
        zipCode: ''
      },
      statementDeliveryMode:'',
      primaryContact: {
        salutation: '',
        lastName: '',
        firstName: '',
        middleName: ''
      },
      primaryContactEmailAddress: '',
      primaryContactTelNo: '',
      nature: '',
      incomeSource: '',
      tin: '',
      taxStatus: '',
      accountNumber: '',
      bankName: '',
      bankBranch: '',
      rejectReason: '',
      createdDate: '',
      lastUpdatedDate: ''
    }
  }
}






